import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lis_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token expired; clear
      localStorage.removeItem("lis_token");
      localStorage.removeItem("lis_user");
    }
    return Promise.reject(err);
  }
);

export const auth = {
  login: (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  saveSession: ({ access_token, user }) => {
    localStorage.setItem("lis_token", access_token);
    localStorage.setItem("lis_user", JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem("lis_token");
    localStorage.removeItem("lis_user");
  },
  getUser: () => {
    try { return JSON.parse(localStorage.getItem("lis_user") || "null"); } catch { return null; }
  },
};

export const enquiriesApi = {
  create: (payload) => api.post("/enquiries", payload).then((r) => r.data),
  list: (status) => api.get("/enquiries", { params: status ? { status } : {} }).then((r) => r.data),
  updateStatus: (id, status) => api.patch(`/enquiries/${id}`, { status }).then((r) => r.data),
  remove: (id) => api.delete(`/enquiries/${id}`).then((r) => r.data),
};

export const blogApi = {
  list: (published = true) => api.get("/blog", { params: { published } }).then((r) => r.data),
  listAll: () => api.get("/blog").then((r) => r.data),
  get: (slug) => api.get(`/blog/${slug}`).then((r) => r.data),
  create: (payload) => api.post("/blog", payload).then((r) => r.data),
  update: (slug, payload) => api.put(`/blog/${slug}`, payload).then((r) => r.data),
  remove: (slug) => api.delete(`/blog/${slug}`).then((r) => r.data),
};

export const clientsApi = {
  list: () => api.get("/clients").then((r) => r.data),
  create: (payload) => api.post("/clients", payload).then((r) => r.data),
  update: (id, payload) => api.patch(`/clients/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/clients/${id}`).then((r) => r.data),
};

export const projectsApi = {
  list: (client_id) => api.get("/projects", { params: client_id ? { client_id } : {} }).then((r) => r.data),
  create: (payload) => api.post("/projects", payload).then((r) => r.data),
  get: (id) => api.get(`/projects/${id}`).then((r) => r.data),
  updateMilestone: (id, milestone) => api.patch(`/projects/${id}/milestone`, milestone).then((r) => r.data),
  remove: (id) => api.delete(`/projects/${id}`).then((r) => r.data),
  portal: () => api.get("/portal/projects").then((r) => r.data),
};

export const statsApi = {
  admin: () => api.get("/admin/stats").then((r) => r.data),
};

export const documentsApi = {
  list: (pid) => api.get(`/projects/${pid}/documents`).then((r) => r.data),
  upload: (pid, file, label = "") => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("label", label);
    return api.post(`/projects/${pid}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  downloadUrl: (docId) => `${API_BASE}/documents/${docId}/download`,
  download: async (docId, filename) => {
    const res = await api.get(`/documents/${docId}/download`, { responseType: "blob" });
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "file";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
  remove: (docId) => api.delete(`/documents/${docId}`).then((r) => r.data),
};

export const commentsApi = {
  list: (pid) => api.get(`/projects/${pid}/comments`).then((r) => r.data),
  create: (pid, body) => api.post(`/projects/${pid}/comments`, { body }).then((r) => r.data),
  remove: (cid) => api.delete(`/comments/${cid}`).then((r) => r.data),
};

export const caseStudiesApi = {
  listPublic: () => api.get("/case-studies", { params: { published: true } }).then((r) => r.data),
  listAll: () => api.get("/case-studies/all").then((r) => r.data),
  get: (slug) => api.get(`/case-studies/${slug}`).then((r) => r.data),
  create: (payload) => api.post("/case-studies", payload).then((r) => r.data),
  update: (slug, payload) => api.put(`/case-studies/${slug}`, payload).then((r) => r.data),
  remove: (slug) => api.delete(`/case-studies/${slug}`).then((r) => r.data),
};
